import { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import { ExperienceEntry } from '@contentful/getExperiences';
import { useExperiences } from '@hooks/data/useExperiences';
import { ExperienceContext } from './MainContextService';

export const ExperiencesProvider: FC<{ children: ReactNode }> = ({ children }) => {
    const [experiences, setExperiences] = useState<ExperienceEntry[] | null>(null);

    const { data, isError } = useExperiences();

    useEffect(() => {
        if (data && !experiences) {
            setExperiences(data as unknown as ExperienceEntry[]);
        }
    }, [data, experiences]);

    const contextValue = useMemo(
        () => ({
            experiences: experiences,
            isError,
        }),
        [experiences, isError],
    );

    return <ExperienceContext.Provider value={contextValue}>{children}</ExperienceContext.Provider>;
};
